import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
const StyledModalHeader = styled('div')(({ theme })=>({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: theme.spacing(1.5, 2.5),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1.5)
        }
    }));
const StyledModalHeaderText = styled(Typography)((props)=>({
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: 0,
        [props.theme.breakpoints.down('sm')]: {
            justifyContent: 'center'
        },
        width: '100%'
    }));
export const ModalHeader = (props)=>/*#__PURE__*/ _jsx(StyledModalHeader, {
        "data-component": "modalHeader",
        children: /*#__PURE__*/ _jsx(StyledModalHeaderText, {
            "data-testid": "modalHeaderText",
            id: props.id,
            variant: "h3",
            children: props.children
        })
    });
ModalHeader.displayName = 'ModalHeader';

//# sourceMappingURL=ModalHeader.js.map